import React from "react";
import { flexRender, Header as TanStackHeader } from "@tanstack/react-table";
import { StyledThead, StyledTh, HeaderContent, SortIcon } from "./styles";

interface HeaderProps {
  headerGroups: any[];
}

export const Header: React.FC<HeaderProps> = ({ headerGroups }) => {
  return (
    <StyledThead>
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header: TanStackHeader<any, unknown>) => {
            const canSort = header.column.getCanSort();
            const sortDirection = header.column.getIsSorted();

            return (
              <StyledTh
                key={header.id}
                $canSort={canSort}
                onClick={
                  canSort ? header.column.getToggleSortingHandler() : undefined
                }
                style={{
                  width:
                    header.getSize() !== 150 ? header.getSize() : undefined,
                }}
              >
                {header.isPlaceholder ? null : (
                  <HeaderContent>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {canSort && (
                      <SortIcon $direction={sortDirection || false}>
                        {sortDirection === "asc" && "▲"}
                        {sortDirection === "desc" && "▼"}
                        {!sortDirection && "⬍"}
                      </SortIcon>
                    )}
                  </HeaderContent>
                )}
              </StyledTh>
            );
          })}
        </tr>
      ))}
    </StyledThead>
  );
};
